<div class="dialog-shell">
	<div class="dialog-header">
		<div>
			<h2 class="fw-bold fs-xs">Detalhes do histórico</h2>
			<p class="fs-xxs gray">
				Visualização somente leitura da ação aplicada nesta divergência.
			</p>
		</div>
		<button mat-icon-button type="button" (click)="onClose()">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<div class="info-grid">
		<div class="info-card">
			<span class="label">Ação</span>
			<strong>{{ action }}</strong>
		</div>
		<div class="info-card">
			<span class="label">Data</span>
			<strong>
				{{ appliedAt ? (appliedAt | date: 'dd/MM/yyyy HH:mm:ss') : '-' }}
			</strong>
		</div>
		<div class="info-card">
			<span class="label">Usuario</span>
			<strong>{{ appliedByName }}</strong>
		</div>
		<div class="info-card">
			<span class="label">Status</span>
			<strong>{{ data.item.status }}</strong>
		</div>
	</div>

	<div class="data-section">
		<h3 class="fw-bold fs-xxs">Dados da plataforma</h3>
		<pre class="json-block">{{ formatJson(data.item.dbValue) }}</pre>
	</div>

	<div class="data-section">
		<h3 class="fw-bold fs-xxs">Dados da base do cliente</h3>
		<pre class="json-block">{{ formatJson(data.item.externalValue) }}</pre>
	</div>

	<div class="data-section">
		<h3 class="fw-bold fs-xxs">Payload usado</h3>
		<pre class="json-block">{{ payloadFormatted }}</pre>
	</div>

	<div class="data-section" *ngIf="data.item.status === 'FAILED'">
		<h3 class="fw-bold fs-xxs">Erro</h3>
		<p class="error-text fs-xxs">{{ errorMessage }}</p>
	</div>
</div>
